import SigninComponent from "../components/auth/Signin";
const StaffSignin = () => {
  return <SigninComponent />;
};
export default StaffSignin;
